export const getFavoritesLabel = (favorites: number, extraContent?: string) => {
  return `${favorites} Other${favorites > 1 ? 's' : ''} ${favorites > 1 ? 'have' : 'has'} favorited ${extraContent ?? ''}`;
};

export const isMobile = () => typeof window !== 'undefined' && window.innerWidth < 768;

export const convertPage = (page: unknown) => {
  if (!page || typeof page !== 'string') {
    return 1;
  }

  const parsed = parseInt(page, 10);

  if (isNaN(parsed) || parsed < 1) {
    return 1;
  }

  return parsed;
};

export const overlayGradientStylesMap: Record<string, string> = {
  'top-bottom': 'bg-gradient-to-b',
  'bottom-top': 'bg-gradient-to-t',
  'left-right': 'bg-gradient-to-r',
  'right-left': 'bg-gradient-to-l',
  'radial-in-out': 'bg-gradient-radial from-[var(--overlay-gradient-to)] to-[var(--overlay-gradient-from)]',
  'radial-out-in': 'bg-gradient-radial',
};

export const hexWithOpacity = (hex: string, percent: number | string, fallback = '#000000') => {
  hex = hex.replace(/^#/, '');

  if (hex.length === 3) {
    hex = hex
      .split('')
      .map((c) => c + c)
      .join('');
  }

  if (!/^([0-9a-f]{6})$/i.test(hex)) {
    return fallback;
  }

  let p = Number(percent);
  if (isNaN(p)) p = 100;
  p = Math.max(0, Math.min(100, p));

  const alpha = Math.round((p / 100) * 255);
  const alphaHex = alpha.toString(16).padStart(2, '0');

  return `#${hex}${alphaHex}`;
};
